import { ModulesMap, ModulesConfigMap } from '../data/modulesMaps'
import { STORE_MAP } from '@/config/cache/cache-engine'

export default {
	getAvailableInfrastructureTypes: {
		useCache: true, //кешируемый флаг
		cacheStorage: STORE_MAP.FULL,
		apiServiceMethodName:
			ModulesConfigMap[ModulesMap.INFRASTRUCTURE_TYPES].GET_AVAILABLE_INFRASTRUCTURE_TYPES,
	},
	getBasedInfrastructureTypes: {
		useCache: true,
		cacheStorage: STORE_MAP.BASE,
		apiServiceMethodName:
			ModulesConfigMap[ModulesMap.INFRASTRUCTURE_TYPES].GET_AVAILABLE_INFRASTRUCTURE_TYPES,
	},
	getExtendedInfrastructureTypes: {
		useCache: true,
		cacheStorage: STORE_MAP.EXTENDED,
		apiServiceMethodName:
			ModulesConfigMap[ModulesMap.INFRASTRUCTURE_TYPES].GET_AVAILABLE_INFRASTRUCTURE_TYPES,
	},
	getFulledInfrastructureTypes: {
		useCache: true,
		cacheStorage: STORE_MAP.FULL,
		apiServiceMethodName:
			ModulesConfigMap[ModulesMap.INFRASTRUCTURE_TYPES].GET_AVAILABLE_INFRASTRUCTURE_TYPES,
	},
	getInfrastructureTypesPreview: {
		apiServiceMethodName:
			ModulesConfigMap[ModulesMap.INFRASTRUCTURE_TYPES].GET_INFRASTRUCTURE_TYPES_PREVIEW,
	},
	getInfrastructureType: {
		useCache: true,
		isSingleCachedEntity: true,
		cacheStorage: STORE_MAP.FULL,
		apiServiceMethodName: ModulesConfigMap[ModulesMap.INFRASTRUCTURE_TYPES].GET_INFRASTRUCTURE_TYPE,
	},
	createInfrastructureTypes: {
		apiServiceMethodName:
			ModulesConfigMap[ModulesMap.INFRASTRUCTURE_TYPES].CREATE_INFRASTRUCTURE_TYPES,
	},
	patchInfrastructureTypes: {
		apiServiceMethodName:
			ModulesConfigMap[ModulesMap.INFRASTRUCTURE_TYPES].PATCH_INFRASTRUCTURE_TYPES,
	},
	putInfrastructureTypes: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.INFRASTRUCTURE_TYPES].PUT_INFRASTRUCTURE_TYPES,
	},
	deleteInfrastructureTypes: {
		apiServiceMethodName:
			ModulesConfigMap[ModulesMap.INFRASTRUCTURE_TYPES].DELETE_INFRASTRUCTURE_TYPES,
	},
}
